/* EYC – rychlé přidání do košíku na kartách produktů (deleguje kliky, funguje i po AJAX překreslení) */
(function () {
  if (window.__eycQuickAdd) return;
  window.__eycQuickAdd = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CUSTOM = /jin|custom/i;

  function step(w, n) {
    var s1 = w.querySelector('[data-eyqa-step1]');
    var s2 = w.querySelector('[data-eyqa-step2]');
    if (s1) s1.hidden = n !== 1;
    if (s2) s2.hidden = n !== 2;
  }
  function focusFirst(w) {
    var f = w.querySelector('.eyqa__pop > :not([hidden]) .eyqa__opt:not([disabled]), .eyqa__pop > .eyqa__opts .eyqa__opt:not([disabled])');
    if (f) f.focus({ preventScroll: true });
  }
  function reveal(w) {
    var p = w.querySelector('.eyqa__pop');
    if (!p || !w.closest('cart-drawer')) return;
    requestAnimationFrame(function () { p.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
  }
  function setOpen(w, open) {
    w.classList.toggle('is-open', open);
    var p = w.querySelector('.eyqa__pop');
    if (p) p.hidden = !open;
    var t = w.querySelector('[data-eyqa-toggle]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) step(w, 1);
  }
  function closeAll(except) {
    document.querySelectorAll('[data-eyqa].is-open').forEach(function (w) { if (w !== except) setOpen(w, false); });
  }

  function showStep2(w, val) {
    var json = w.querySelector('[data-eyqa-variants]');
    var data = [];
    try { data = JSON.parse(json.textContent); } catch (_) {}
    var box = w.querySelector('[data-eyqa-step2-opts]');
    box.innerHTML = '';
    data.filter(function (x) { return x[1] === val; }).forEach(function (x) {
      var el;
      if (CUSTOM.test(x[2] || '')) {
        el = document.createElement('a');
        el.className = 'eyqa__opt eyqa__opt--link';
        el.href = w.dataset.url + '?variant=' + x[0];
        el.textContent = x[2] + ' – zadat míry →';
      } else {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'eyqa__opt';
        el.dataset.eyqaAdd = x[0];
        el.textContent = x[2];
        if (!x[3]) { el.disabled = true; el.setAttribute('aria-label', x[2] + ' – vyprodáno'); }
      }
      box.appendChild(el);
    });
    w.querySelector('[data-eyqa-step2-label]').textContent = val;
    step(w, 2);
    focusFirst(w);
    reveal(w);
  }

  function add(id, el) {
    var wrap = el.closest('[data-eyqa]');
    var main = wrap.querySelector('.eyqa__btn');
    if (main.classList.contains('is-loading')) return;
    main.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var p;
    if (drawer && typeof drawer.add === 'function') {
      p = drawer.add(id, null).then(function () { if (drawer.setActiveElement) drawer.setActiveElement(main); drawer.open(false); });
    } else {
      p = fetch(ROOT + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) { if (r.ok) window.location.href = ROOT + 'cart'; });
    }
    p.catch(function () {}).finally(function () {
      main.classList.remove('is-loading');
      setOpen(wrap, false);
      main.classList.add('is-done');
      setTimeout(function () { main.classList.remove('is-done'); }, 1400);
    });
  }

  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-eyqa-add]'))) { e.preventDefault(); e.stopPropagation(); if (!el.disabled) add(el.dataset.eyqaAdd, el); return; }
    if ((el = e.target.closest('[data-eyqa-o1]'))) { e.preventDefault(); e.stopPropagation(); if (!el.disabled) showStep2(el.closest('[data-eyqa]'), el.dataset.eyqaO1); return; }
    if ((el = e.target.closest('[data-eyqa-back]'))) { e.preventDefault(); e.stopPropagation(); var wb = el.closest('[data-eyqa]'); step(wb, 1); focusFirst(wb); return; }
    if ((el = e.target.closest('[data-eyqa-toggle]'))) {
      e.preventDefault(); e.stopPropagation();
      var w = el.closest('[data-eyqa]');
      var open = !w.classList.contains('is-open');
      closeAll(w);
      setOpen(w, open);
      if (open) { focusFirst(w); reveal(w); }
      return;
    }
    if (!e.target.closest('.eyqa__pop')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var w = document.querySelector('[data-eyqa].is-open');
    if (!w) return;
    e.stopPropagation();
    setOpen(w, false);
    var t = w.querySelector('[data-eyqa-toggle]');
    if (t) t.focus({ preventScroll: true });
  }, true);
})();
